/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMapCheck = createReactComponent("outline", "map-check", "IconMapCheck", [["path", { "d": "M11 18l-2 -1l-6 3v-13l6 -3l6 3l6 -3v9", "key": "svg-0" }], ["path", { "d": "M9 4v13", "key": "svg-1" }], ["path", { "d": "M15 7v8", "key": "svg-2" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-3" }]]);

export { IconMapCheck as default };
//# sourceMappingURL=IconMapCheck.mjs.map
